// Keep this file super simple without any dependencies or logic that could cause errors
// to ensure it can be rendered always.

import { errorPageTexts } from '../common/texts'

// Note all pages are wrapped within a Layout component,
// but this page is not. Keep in sync with MainLayout and NavigationBar.

export function ErrorPage() {
  function handleClick(): void {
    window.location.reload()
  }

  const buttonColor = 'primary'
  const buttonColorClasses = `bg-${buttonColor} border-${buttonColor} hover:bg-${buttonColor}-700 hover:border-${buttonColor}-700 `

  return (
    <main className="surface-50 min-h-screen">
      <div className="mb-5 px-5 py-3 max-w-6xl bg-white border-noround shadow-1 border-none flex justify-content-center">
        <div className="max-w-app flex justify-content-between max-w-screen-xl flex-grow-1">
          <a href="/" className="flex">
            <img src="/logo.svg" alt="Sunweb Group logo" className="w-auto w-8rem" />
          </a>
        </div>
      </div>
      <div className="px-3 sm:px-5 xl:mt-0 mt-8">
        <div className="sm:flex sm:flex-row max-w-app mx-auto pb-8">
          <div className="flex-grow-1 min-w-0 sm:ml-3">
            <h1 className="text-2xl font-bold mb-4">{errorPageTexts.title}</h1>
            <p>{errorPageTexts.message}</p>
            <p>{errorPageTexts.contactSupportMessage}</p>
            <button onClick={handleClick} type="button" className={`p-2 cursor-pointer text-white border-round border-solid font-bold ${buttonColorClasses}`}>
              {errorPageTexts.refreshButtonLabel}
            </button>
          </div>
        </div>
      </div>
    </main>
  )
}
